// Persists "the app-download prompt has been dismissed on this device" in localStorage.
//
// localStorage (not a cookie) is deliberate: the whole problem this prompt addresses is a
// first, cookie-less visit, so persistence must not depend on cookies. The key is scoped by
// the online app code so each app remembers its own dismissal independently.

const KEY_PREFIX = 'app_download_prompt_dismissed';

export default class Dismissal {

    constructor(appCode) {
        this.key = `${appCode}__${KEY_PREFIX}`;
    }

    isDismissed() {
        try {
            return window.localStorage.getItem(this.key) === '1';
        } catch (error) {
            // localStorage can throw (private mode, disabled storage). Treat as not-dismissed
            // rather than failing — worst case the prompt shows again.
            return false;
        }
    }

    markDismissed() {
        try {
            window.localStorage.setItem(this.key, '1');
        } catch (error) {
            // Nothing we can do if storage is unavailable; the prompt may show again next visit.
        }
    }

}
